import { render, staticRenderFns } from "./digikalaOrderList.vue?vue&type=template&id=19f5340b&scoped=true&"
import script from "./digikalaOrderList.vue?vue&type=script&lang=js&"
export * from "./digikalaOrderList.vue?vue&type=script&lang=js&"
import style0 from "./digikalaOrderList.vue?vue&type=style&index=0&id=19f5340b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f5340b",
  null
  
)

export default component.exports